/**
 * Created by Ning Jiang on 2021-12-07.
 */

import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {DeadwoodRipSound} from "./DeadwoodRipSound";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";

export class SoundEffectGroup {

    private readonly _names:string[];
    private _lastIndex:number = -1;
    private _orderIndex:number = -1;
    private _lastTime:number;

    constructor(names:string[]) {
        this._names = names.concat();
    }

    public playRandomNoOverlap():NolimitHowl | undefined {
        let now = Date.now();
        if(now - this._lastTime < 50) {
            return undefined;
        }

        this._lastTime = now;
        return this.playRandom();
    }

    public playRandom():NolimitHowl | undefined {
        let index;
        if(this._names.length === 1) {
            index = 0;
        } else {
            index = MathHelper.randomNumberInRange(0, this._names.length - 1, 0);
            while(index === this._lastIndex) {
                index = MathHelper.randomNumberInRange(0, this._names.length - 1, 0);
            }
            this._lastIndex = index;
        }

        return DeadwoodRipSound.soundPlayer.playTrack({name : this._names[index]});
    }

    public playInOrder(start:boolean):boolean {
        let now = Date.now();
        if(now - this._lastTime < 50) {
            return false;
        }
        this._lastTime = now;

        if(start) {
            this._orderIndex = 0;
        } else {
            this._orderIndex++;
            if(this._orderIndex >= this._names.length) {
                this._orderIndex = 0;
            }
        }
        this._lastIndex = this._orderIndex;
        DeadwoodRipSound.soundPlayer.playTrack({name : this._names[this._orderIndex]});
        return true;
    }
}